import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';

import { environment } from '@environments/environment';

declare let __ucCmp: any;

@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  readonly year: string;

  constructor() {
    this.year = String(new Date().getFullYear());
  }

  openCookieSettings(e: MouseEvent): void {
    e.preventDefault();
    if (!environment.production) {
      return;
    }
    __ucCmp.showSecondLayer();
  }
}
